<form id="informations-client-form" class="px-4" [formGroup]="immeubleForm">
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>

    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.constructionYear"
        id="constructionYear"
        name="constructionYear"
        label="Année de construction"
        [maxLengthNumber]="4"
        (input)="onConstructionYearChanged($event)"
        type="number"
        errorMessage="L'année de construction doit être un nombre à 4 chiffres."
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.numberOfUnits"
        id="numberOfUnits"
        name="numberOfUnits"
        label="Nb de logements/lots"
        placeholder="Ex : 100"
        type="number"
        (input)="onNumberOfUnitsChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-select
        id="hasElevator"
        [items]="yesNoSelectItems"
        [selectedItem]="hasElevatorItem"
        label="Ascenseur"
        (selected)="onHasElevatorSelected($event)"
      ></p-select>
    </div>
    <div class="col-4">
      <p-select
        id="hasCondominium"
        [items]="yesNoSelectItems"
        [selectedItem]="hasCondominiumItem"
        label="Copropriété"
        (selected)="onHasCondominiumSelected($event)"
      ></p-select>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.profitability"
        type="number"
        id="profitability"
        name="profitability"
        label="Rentabilité"
        placeholder="Ex : 10"
        fixedText="%"
        (input)="onProfitabilityChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.totalAreaM2"
        type="number"
        id="totalAreaM2"
        name="totalAreaM2"
        label="Surface totale"
        fixedText="m²"
        placeholder="Ex : 1000"
        (input)="onTotalAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="immeubleForm.controls.premisesUsage"
        id="premisesUsage"
        name="premisesUsage"
        label="Usage des locaux"
        placeholder="Ex : commercial"
        (input)="onPremisesUsageChanged($event)"
      ></p-input>
    </div>
  </div>
</form>
